import { Monitor } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ComputerIcon = createLucideIcon(Monitor);
